import { createFileRoute } from "@tanstack/react-router";
import DocsIndexPage from "@/pages/docs/DocsIndexPage";

export const Route = createFileRoute("/docs/")({
  component: DocsIndexPage,
});
